export const SIDEBAR_MENU_SUB_INDENT = 16;
export const INSERTION_BUTTON_SIZE = 12;

export const AFTER_CONTAINER_HOVER_OFFSET_PX = 8;

export const DRAG_ACTIVATION_DISTANCE = 8;
export const DROP_AFTER_ZONE_PX = 4;
export const AUTO_EXPAND_DELAY_MS = 700;
